import React, { ImgHTMLAttributes } from 'react';

// Styles
import { Container, Imagem } from './styles';

// Interface
interface LogoProps extends ImgHTMLAttributes<HTMLImageElement> {}

export function Logo({ ...props }: LogoProps) {
  return (
    <Container>
      <Imagem {...props} />
    </Container>
  );
}
